export enum ProblemTypeCode {
  EATING_DISORDER = 'EATING_DISORDER',
  MEDICAL = 'MEDICAL',
  PSYCHIATRIC = 'PSYCHIATRIC',
}
